var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./TimeComponent.scss";
import { EventHandler } from "../../interaction/eventhandler";
import { helper } from "../../core/helper";
import { date } from "../../core/date";
var TimeComponent = /** @class */ (function () {
    function TimeComponent(options) {
        var _a;
        this.options = __assign({
            enabled: true,
            id: helper.newDomGuid(),
            inputMode: "HourMinute",
            bindMode: "toModel",
            placeholder: (options === null || options === void 0 ? void 0 : options.inputMode) === "HourMinuteSecond" ? "__:__:__" : "__:__"
        }, options);
        if (this.options.bindTo != null && this.options.bindMode !== "fromModel" && this.options.property != null && this.options.value == null) {
            this.options.value = (((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ?
                this.options.converter.toUI(this.options.bindTo[this.options.property]) :
                this.options.bindTo[this.options.property]);
        }
        this.options.onChange = EventHandler.Create(this.options.onChange);
    }
    TimeComponent.prototype.render = function () {
        var _a, _b;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var current = this.getValue();
            var newVal = (((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ?
                this.options.converter.toUI(this.options.bindTo[this.options.property]) :
                this.options.bindTo[this.options.property]);
            var newValStr = date.formatTime(newVal, this.options.inputMode);
            if (newValStr !== current) {
                val = newVal;
                if (this.currentDom != null) {
                    this.currentDom.value = newValStr;
                }
            }
        }
        return {
            tag: "input", attr: {
                id: this.options.id,
                enabled: this.options.enabled,
                value: date.formatTime(val, this.options.inputMode),
                class: "time-comp " + ((_b = this.options.class) !== null && _b !== void 0 ? _b : ""),
                style: this.options.style,
                placeholder: this.options.placeholder,
                change: this.raiseChangeEvent
            }
        };
    };
    TimeComponent.prototype.onCreate = function (node) {
        this.currentDom = node.dom;
    };
    TimeComponent.prototype.onUpdate = function (node) {
        this.currentDom = node.dom;
    };
    TimeComponent.prototype.getValue = function () {
        if (this.currentDom == null) {
            return "";
        }
        return this.currentDom.value;
    };
    TimeComponent.prototype.getValueAsDate = function (datePart) {
        var x = datePart ? new Date(datePart.getTime()) : new Date();
        try {
            var parts = this.getValue().split(":");
            x.setHours(parseInt(parts[0], 10));
            if (parts.length > 1) {
                x.setMinutes(parseInt(parts[1], 10));
            }
            else {
                x.setMinutes(0);
            }
            if (this.options.inputMode === "HourMinuteSecond" && parts.length > 2) {
                x.setSeconds(parseInt(parts[2], 10));
            }
            else {
                x.setSeconds(0);
            }
        }
        catch (e) {
            console.log(e);
            this.currentDom.value = "";
            x.setHours(0);
            x.setMinutes(0);
            x.setSeconds(0);
        }
        return x;
    };
    TimeComponent.prototype.raiseChangeEvent = function (e, node) {
        var _a;
        if (this.options.enabled) {
            var val = this.getValueAsDate(this.options.value);
            if (this.options.bindTo && this.options.bindMode !== "fromModel" && this.options.property) {
                this.options.bindTo[this.options.property] =
                    ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(val) : val;
            }
            this.options.onChange.notify(val);
        }
    };
    return TimeComponent;
}());
export { TimeComponent };
